import { render, staticRenderFns } from "./editExtraPackaging.vue?vue&type=template&id=1a8b6e7b&"
import script from "./editExtraPackaging.vue?vue&type=script&lang=js&"
export * from "./editExtraPackaging.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports